module.exports = __webpack_public_path__ + "img/signable_cropped.41ba0926.svg";